"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EngineeredForEfficiency() {
  const {
    ref: topTextRef,
    isVisible: topTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: leftColRef,
    isVisible: leftColVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: rightColVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="259044" id="engineered-for-efficiency" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        {}
        <div ref={topTextRef} className={`mb-12 md:mb-16 transition-all duration-700 ease-out ${topTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="block text-sm font-semibold tracking-widest text-primary uppercase mb-3 font-default">
            The Technology
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-foreground font-default font-bold leading-tight">
            Engineered for the Modern Contractor
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftColRef} className={`space-y-6 transition-all duration-700 delay-200 ease-out ${leftColVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <p className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed">
              The ClifRock panel masonry system is a revolutionary leap in outdoor construction. By utilizing high-performance fiber-reinforced concrete, we've eliminated the need for heavy footings and traditional masonry labor.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="mt-1 bg-primary/10 p-1 rounded-md">
                  <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
                </div>
                <p className="text-base md:text-lg text-muted-foreground font-sans">90% lighter than traditional stone masonry, reducing structural requirements.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="mt-1 bg-primary/10 p-1 rounded-md">
                  <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
                </div>
                <p className="text-base md:text-lg text-muted-foreground font-sans">Install full outdoor kitchens and water features in days, not weeks.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="mt-1 bg-primary/10 p-1 rounded-md">
                  <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
                </div>
                <p className="text-base md:text-lg text-muted-foreground font-sans">Weather-resistant technology designed to withstand extreme freeze-thaw cycles.</p>
              </div>
            </div>
            <div className="pt-4">
              <a href="/WhyClifRockPage" className="inline-block bg-primary text-primary-foreground px-8 py-4 rounded-lg font-default font-semibold shadow-lg hover:bg-secondary transition-colors duration-300">
                View Technical Specs
              </a>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`relative transition-all duration-700 delay-400 ease-out ${rightColVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-2xl border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_exploded_view_panel.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_exploded_view_panel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_exploded_view_panel.png-wvc-sizes" alt="ClifRock Panel System Technology" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto" loading="lazy" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}